import React from 'react';
import ActionPointRenderer from '../../ActionLinks/ActionPointRenderer';

export default function ActionPoint(props) {
	return <ActionPointRenderer {...props} />;
}
